var map = {
	"./custom.svg": "3ff3",
	"./magento.svg": "079a",
	"./opencart.svg": "79bc1",
	"./presta-shop.svg": "7c67",
	"./shopify.svg": "7608",
	"./woo.svg": "ad85"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0967";